/** Desktop interaction receipts as the conversation's step list shows them. */
export default {
  sequence: "Desktop sequence",
  actionsCompleted: {
    one: "{count} action completed · {result}",
    other: "{count} actions completed · {result}",
  },

  runAll: "{label} x{count}",
  runRequested: "{label}, {count} requested",
  runStopped: "{label}, {ran} of {count} before you stopped it",
  runSoFar: "{label}, {ran} of {count} so far",
  runRecorded: "{label}, {ran} of {count} recorded",

  actionPressed: "Pressed",
  actionFocused: "Focused",
  actionClicked: "Clicked",
  actionDoubleClicked: "Double-clicked",
  actionDragged: "Dragged",
  actionScrolled: "Scrolled",
  actionPressedKey: "Pressed key",

  resultChangeVerified: "Change verified",
  resultNoChange: "Completed; no state change observed",
  resultQueued: "Queued",
  resultPlaying: "Playing",
  resultWaiting: "Waiting for your action",
  resultStopped: "Stopped",
  resultStoppedInspect: "Stopped; inspection required",
  resultUnknown: "Playback status unknown",
  resultFailed: "Failed",
  resultRejected: "Rejected",
  resultCompleted: "Completed",
  resultRecorded: "Result recorded",
} as const;
